export default __webpack_public_path__ + "not-found-img.718c0030ac660516d3764485c2190703.png";